// import FbaConsignmentList from '@/pages/FbaConsignmentList';
// import FbaConsignmentDetail from '@/pages/FbaConsignmentDetail';
// import FbaDeliverList from '@/pages/FBADeliver/FbaDeliverList';
// import FbaDeliverDetail from '@/pages/FBADeliver/FbaDeliverDetail';
// import FbaDeliverEdit from '@/pages/FBADeliver/FbaDeliverEdit';
// import FbaDeliverAbnormalList from '@/pages/FBADeliver/FbaDeliverAbnormalList';

// // 打托
// import FbaPalletManage from '@/pages/FbaPalletManage';
// import FbaPalletDetail from '@/pages/FbaPalletDetail';
// import FbaPalletReport from '@/pages/FbaPalletReport';

// // 入库
// import FbaInboundList from '@/pages/FbaInboundList';
// import FbaInboundException from '@/pages/FbaInboundException';
// import FbaInboundDetail from '@/pages/FbaInboundDetail';
import React from 'react';

export default [
  {
    path: '/fba/consignment/list',
    // component: FbaConsignmentList,
    component: React.lazy(() => import(/* webpackChunkName: 'FbaConsignmentList' */ '@/pages/FbaConsignmentList')),
  },

  {
    path: '/fba/consignment/detail/:consignmentNo',
    // component: FbaConsignmentDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'FbaConsignmentDetail' */ '@/pages/FbaConsignmentDetail')),
  },

  {
    path: '/fba/deliver/list',
    // component: FbaDeliverList,
    component: React.lazy(() => import(/* webpackChunkName: 'FbaDeliverList' */ '@/pages/FBADeliver/FbaDeliverList')),
  },

  {
    path: '/fba/deliver/detail/:jobNo',
    // component: FbaDeliverDetail,
    component: React.lazy(
      () => import(/* webpackChunkName: 'FbaDeliverDetail' */ '@/pages/FBADeliver/FbaDeliverDetail'),
    ),
  },

  {
    path: '/fba/deliver/edit/:jobNo',
    // component: FbaDeliverEdit,
    component: React.lazy(() => import(/* webpackChunkName: 'FbaDeliverEdit' */ '@/pages/FBADeliver/FbaDeliverEdit')),
  },

  {
    path: '/fba/deliver/abnormal',
    // component: FbaDeliverAbnormalList,
    component: React.lazy(
      () => import(/* webpackChunkName: 'FbaDeliverAbnormalList' */ '@/pages/FBADeliver/FbaDeliverAbnormalList'),
    ),
  },

  {
    path: '/fba/pallet/list',
    // component: FbaPalletManage,
    component: React.lazy(() => import(/* webpackChunkName: 'FbaPalletManage' */ '@/pages/FbaPalletManage')),
  },
  {
    path: '/fba/pallet/detail/:consignmentNo',
    // component: FbaPalletDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'FbaPalletDetail' */ '@/pages/FbaPalletDetail')),
  },
  {
    path: '/fba/pallet/report',
    // component: FbaPalletReport,
    component: React.lazy(() => import(/* webpackChunkName: 'FbaPalletReport' */ '@/pages/FbaPalletReport')),
  },
  {
    path: '/fba/inbound/list',
    // component: FbaInboundList,
    component: React.lazy(() => import(/* webpackChunkName: 'FbaInboundList' */ '@/pages/FbaInboundList')),
  },
  {
    path: '/fba/inbound/exception',
    // component: FbaInboundException,
    component: React.lazy(() => import(/* webpackChunkName: 'FbaInboundException' */ '@/pages/FbaInboundException')),
  },
  {
    path: '/fba/inbound/detail/:consignmentNo',
    // component: FbaInboundDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'FbaInboundDetail' */ '@/pages/FbaInboundDetail')),
  },
];
